/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PipesModule} from '../../../shared/pipes/pipes.module';
import {PartNumberChangesRejectMotivationComponent} from './part-number-changes-reject-motivation.component';

@NgModule({
    declarations: [PartNumberChangesRejectMotivationComponent],
    imports: [
        CommonModule,
        PipesModule
    ],
    exports: [
        PartNumberChangesRejectMotivationComponent
    ]
})
export class PartNumberChangesRejectMotivationModule {
}
